import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import Avatar from "components/Avatar/Avatar";
const SidebarProfile = ({ condensed = false }) => {
  const { user } = useSelector((state) => state.profile);

  return (
    <div className={`sidebar-profile ${condensed ? "condensed" : ""}`}>
      <Avatar 
        src={user?.profilePicture} 
        alt={`${user?.firstName} ${user?.lastName}`} 
        style={{ flexShrink: 0 }}
      />
      {!condensed && (
        <div className="profile-info min-w-0">
          <div className="me-2 text-start" style={{ overflow: 'hidden' }}>
            <div 
              className="profile-name mb-0 font-semibold text-truncate"
              style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
            >
              {user?.firstName ? `${user?.firstName} ${user?.lastName || ""}`.trim() : "ไม่ระบุตัวตน"}
            </div>
            <p 
              className="profile-email mb-0 text-truncate"
              style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
            >
              {user?.email || "ไม่ระบุอีเมล"}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

SidebarProfile.propTypes = {
  condensed: PropTypes.bool,
};

export default SidebarProfile;
